// ////<reference path="../../../../../node_modules/@angular/core/src/metadata/lifecycle_hooks.d.ts"/> //todo: does it still work without triple slash directive?
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurableImageComponent } from '../configurable-image.component';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ImageConfigEntry } from '../../../core/base-api';
import { NgTemplateOutlet } from '@angular/common';
import SizeTypeEnum = ImageConfigEntry.SizeTypeEnum;

@Component({
  selector: 'cap-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  imports: [NgTemplateOutlet, TranslatePipe]
})
export class LogoComponent extends ConfigurableImageComponent {
  @ViewChild('default', { static: false })
  defaultTemplate: TemplateRef<any>;
  @ViewChild('large', { static: false })
  largeTemplate: TemplateRef<any>;

  constructor(router: Router, route: ActivatedRoute, formatService: FormatConfigService, translateService: TranslateService) {
    super(router, route, 'START_PAGE_IMAGE', formatService, translateService);
    keysToTranslate<string>(['shared.logo.grundstueckInformationen']);
  }

  getSizeTemplate(imageSize: SizeTypeEnum): TemplateRef<any> {
    return imageSize === 'LARGE' ? this.largeTemplate : this.defaultTemplate;
  }

  registerImagePaths() {
    this.bindImages('START_PAGE_IMAGE_BE', 'assets/img/grudisBE.png');
    this.bindImages('START_PAGE_IMAGE_AG', 'assets/img/agobisAG.gif');
    this.bindImages('START_PAGE_IMAGE_DE_DEFAULT', 'assets/img/capwebStandard_de.gif');
    this.bindImages('START_PAGE_IMAGE_FR_DEFAULT', 'assets/img/capwebStandard_fr.gif');
  }
}
